var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AnimatePresence, motion } from "framer";
import { useMemo } from "react";
import { useGlobalState } from "../../store/store";
import ProductCatalogueGridView from "./ProductCatalogueGridView";
var DesktopProductCatalogue = function (_a) {
    var variant = _a.variant, vaultIcon = _a.vaultIcon, props = __rest(_a, ["variant", "vaultIcon"]);
    var _b = useGlobalState("desktopView"), view = _b[0], setView = _b[1];
    var body = useMemo(function () {
        // if (variant === "landing") {
        //   return (
        //     <DesktopProductCatalogueGalleryView
        //       variant={variant}
        //       setView={setView}
        //       {...props}
        //     />
        //   );
        // }
        switch (view) {
            case "grid":
                return (_jsx(ProductCatalogueGridView, __assign({ vaultIcon: vaultIcon, setView: setView }, props, { variant: "desktop" }), void 0));
            // case "gallery":
            //   return (
            //     <DesktopProductCatalogueGalleryView
            //       variant={variant}
            //       setView={setView}
            //       {...props}
            //     />
            //   );
        }
    }, [props, variant, view, setView]);
    return (_jsx(AnimatePresence, __assign({ exitBeforeEnter: true, initial: false }, { children: _jsx(motion.div, __assign({ initial: {
                opacity: 0,
            }, animate: {
                opacity: 1,
            }, exit: {
                opacity: 0,
            }, transition: {
                duration: 0.2,
                type: "keyframes",
                ease: "easeOut",
            }, className: "w-100" }, { children: body }), view) }), void 0));
};
export default DesktopProductCatalogue;
//# sourceMappingURL=DesktopProductCatalogue.js.map